// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Et-z","tooltipWrapper":"Ft-z","icon":"Gt-z","tooltip":"Ht-z","content":"It-z"};